module.exports = __webpack_public_path__ + "img/80-52db88.png";